/**
 * Quick-add buttons (`.js-upsell-add`): the size pills and "+ In winkelwagen" button on
 * product cards (snippets/card-quick-add.liquid, used by the collection grid and the
 * homepage carousels) and the cross-sell buttons in the cart drawer and on the cart page
 * (snippets/cart-upsell-smart-card.liquid).
 *
 * Loaded globally from layout/theme.liquid, on purpose:
 * - The handler used to live in an inline <script> inside cart-upsell-smart.liquid, which
 *   bails out when the cart is empty, so product cards had no handler at all and the click
 *   fell through to the surrounding product link.
 * - The cart drawer re-renders itself with `innerHTML` (cart-drawer-bub.liquid), and inline
 *   scripts inserted that way never execute.
 *
 * Clicks are delegated on `document` so buttons injected later keep working. The click posts
 * the button's own variant id to /cart/add.js and dispatches `cart:update`, the event
 * cart-drawer-bub listens for to refresh the drawer and open it.
 */
(function () {
  if (window.__bubUpsellDelegated) return;
  window.__bubUpsellDelegated = true;

  var SPINNER =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"></path></svg>';
  var CHECK =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="16" height="16"><polyline points="20 6 9 17 4 12"></polyline></svg>';
  var RESET_DELAY = 1500;

  /**
   * Spins the loading icon. Driven from JS instead of a CSS keyframe because the buttons
   * live on pages that do not load the cart upsell stylesheet.
   * @param {Element} button - The button holding the spinner icon.
   */
  function spin(button) {
    var icon = button.firstElementChild;
    if (!icon || typeof icon.animate !== 'function') return;
    icon.animate([{ transform: 'rotate(0deg)' }, { transform: 'rotate(360deg)' }], {
      duration: 700,
      iterations: Infinity,
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    var button = target ? target.closest('.js-upsell-add') : null;
    if (!button) return;

    /* Product cards wrap the button in the product link, so cancel that navigation. */
    event.preventDefault();

    var variantId = button.getAttribute('data-vid');
    if (!variantId || button.getAttribute('data-loading') === '1') return;

    var original = button.innerHTML;
    button.setAttribute('data-loading', '1');
    button.innerHTML = SPINNER;
    spin(button);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.description || 'add failed');
          });
        }
        return response.json();
      })
      .then(function () {
        button.innerHTML = CHECK;
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: { source: 'card-quick-add', itemCount: 1 },
          })
        );
        /* Restore the label so the same size can be added again. */
        setTimeout(function () {
          button.innerHTML = original;
          button.removeAttribute('data-loading');
        }, RESET_DELAY);
      })
      .catch(function (error) {
        console.error('[quick-add] Add to cart failed:', error);
        button.innerHTML = original;
        button.removeAttribute('data-loading');
      });
  });
})();
